import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{
  selected?: boolean;
  typeSelectCreate?: boolean;
  width?: string;
  height?: string;
}>`
  width: ${p => p.width || '130px'};
  height: ${p => p.height || '108px'};
  background: #fff;

  padding: 8px 6px;

  border-radius: ${props => props.theme.radius.md};
  border: 1px solid
    ${props =>
      props.selected && !props.typeSelectCreate
        ? props.theme.colors.primary.main
        : '#FFF'};

  box-shadow: ${props =>
    props.selected && props.typeSelectCreate ? '0 2px 6px #e1e1e1' : 'none'};

  flex-shrink: 0;

  position: relative;
  box-sizing: border-box;
  transition: all 0.2s;

  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 6px #e1e1e1;
  }

  display: flex;
  align-items: flex-start;
  justify-content: center;

  .ant-skeleton-element {
    width: 100%;
  }
`;

export const MobileWrapper = styled.div<{
  selected?: boolean;
  typeSelectCreate?: boolean;
  width?: string;
  height?: string;
}>`
  width: ${p => p.width || '110px'};
  height: ${p => p.height || '110px'};
  background: #fff;

  border: 1px solid
    ${props =>
      props.selected && !props.typeSelectCreate
        ? props.theme.colors.primary.main
        : '#FFF'};

  background: ${props =>
    props.selected
      ? 'linear-gradient(0deg, rgba(57, 181, 74, 0.1), rgba(57, 181, 74, 0.1)), #FFFFFF;'
      : 'none'};

  //flex-shrink: 0;

  position: relative;
  box-sizing: border-box;
  transition: all 0.2s;

  cursor: pointer;

  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .ant-skeleton-element {
    width: 100%;
  }
  border-radius: ${p => p.theme.radius.md};

  &::before {
    content: '✓';
    width: 25px;
    height: 30px;
    color: #ffffff;
    display: ${p => (p.selected ? 'flex' : 'none')};
    align-items: flex-start;
    justify-content: flex-start;
    text-align: start;
    padding-left: 8px;

    right: 0px;
    font-size: 18px;
    bottom: -8px;
    background: ${p => (p.selected ? p.theme.colors.primary.main : '#fff')};
    border-top-left-radius: 999px;
    //opacity: 0.1;

    position: absolute;
  }
`;

export const Image = styled.img`
  height: 48px;
  width: 90%;
  object-fit: contain;
`;

export const ImageMobile = styled.img`
  height: 48px;
  width: 90%;
  object-fit: contain;
`;

export const IconStyles = css`
  position: absolute;
  top: 8px;
  right: 8px;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  text-align: center;
  .ant-skeleton-element {
    width: 100%;
    height: 100%;
  }
`;
export const ImageMobileWrapper = styled.div`
  padding-top: 8px;
  width: 100%;
  text-align: center;
  .ant-skeleton-element {
    width: 100%;
    height: 100%;
  }
`;
